import { render, staticRenderFns } from "./SelectAddress.vue?vue&type=template&id=55c66018&scoped=true&"
import script from "./SelectAddress.vue?vue&type=script&lang=js&"
export * from "./SelectAddress.vue?vue&type=script&lang=js&"
import style0 from "./SelectAddress.vue?vue&type=style&index=0&id=55c66018&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c66018",
  null
  
)

export default component.exports